import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import { useAnalytics } from '../../analytics/useAnalytics';
import { AppBar } from '../../components/AppBar';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { signOut } from '../../store/authSlice';
import { RequireAuth } from '../../auth/RequireAuth';
import { useScrollReset } from './useScrollReset';

// **The one place the app is put behind auth.** Every route nested under this
// layout route inherits the guard, so a new page is protected by default and
// forgetting to protect one is not a thing that can happen quietly. Only /login
// and the auth callback sit outside it.
//
// useAnalytics lives here too, deliberately: it only ever runs once RequireAuth
// has admitted the render, so an unauthenticated visitor to /login gets no
// analytics script and no Google cookies at all.
//
// **The AppBar is connected here rather than reading the store itself.** It is a
// presentational component with two props; the layout is the one place that
// knows about both the session and the chrome, which keeps the bar renderable in
// a test without a store.
export const ProtectedLayout = () => {
  useAnalytics();
  useScrollReset();

  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);

  return (
    <RequireAuth>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <AppBar
          userLabel={user === null ? null : (user.email ?? user.name ?? user.subject)}
          sdlcAccess={user?.sdlcAccess ?? false}
          onSignOut={() => {
            void dispatch(signOut());
          }}
        />
        <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </Box>
      </Box>
    </RequireAuth>
  );
};
